import styled from 'styled-components';

export const PlayersList = styled.div`
    width: 100%;
    height: 140px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    border: 1px solid #444;
    margin-bottom: 10px;
`;

export const Player = styled.div`
    height: 30px;
    min-height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0 5px;

    &:hover {
        background-color: #222;
    }

    &.selected {
        background-color: #333;
    }

    &.selected:hover {
        background-color: #444;
    }
`;

export const PlayerName = styled.div`
    flex: 1;
    font-size: 12px;
    color: #fff;
`;
